import { api } from "@/api"
import { queryClient } from "@/queryClient"

export const cancelImport = async (importId: string) => {
  const { body } = await api.post(
    `/imports/${importId}/cancel/`
  )
  queryClient.invalidateQueries({
    queryKey: [BASE_PRODUCT_IMPORT_QUERY_KEY],
  })
  return body
}
